import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callGetActiveVehiclePackage, callGetActiveVehicleType, callGetExportVehicleContract } from "../../../api/contract/service"
import { callExportVehicleContract } from "../../../api/export"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import insuranceStatus from "../../../data/insuranceStatus"
import { convertStringToJson, decodeBase64, FormatCurrencys } from "../../../utils/commonUtil"
import { callGetAllProvince } from "../../../api/settings/service";
import reports from '../../../data/reportAgent'
import FilterableDropdown from "../../../components/common/select-component";
import BackPrevious from "../../../components/back-previous";
import { useParams } from "react-router-dom";
import SmartTable from "../../../components/common/table-component";

const Index = () => {
	const params = useParams();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({
		page: 1, type: 2, maxResult: 10, keyword: '', startDate: null, endDate: null, status: "",
		agentCode: '', contractNo: '', reportType: 0, reportValue: '', provinceId: '', packageId: '', vehicleBrandId: '', isRepairCenter: '', updateBy: ''
	});
	const [vehicleContractList, setVehicleContractList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const [fromDate, setFromDate] = useState(null);
	const [fromPayDate, setFromPayDate] = useState(null);
	const [toPayDate, setToPayDate] = useState(null);
	const [toDate, setToDate] = useState(null);
	const [provinceList, setProvinceList] = useState([]);
	const [packageListType, setPackageListType] = useState([]);
	const [packageList, setPackageList] = useState([]);
	useEffect(() => {
		loadProvince();
		loadPackageType();
		const initializeContract = async () => {
			if (!params?.data) {
				loadData();
				return;
			}
			try {
				const decoded = decodeBase64(params.data);
				if (!decoded) return;

				const data = convertStringToJson(decoded);
				if (!data) return;
				console.log(data)
				setRequest((prev) => ({
					...prev,
					agentCode: data.agentCode,
					type: 2,
					reportType: data.reportValue ? 1 : 0,
					reportValue: data.reportValue,
					status: data.status === 1 ? 4 : !data.status ? '' : 3,
				}));
				setFromDate(data.fromDate)
				setToDate(data.toDate)
				loadData(2, data.agentCode, data.fromDate, data.toDate, data.status === 1 ? 4 : !data.status ? '' : 3, data.reportValue);
			} catch (error) {
				console.error("Initialize contract error:", error);
			}
		};

		initializeContract();

	}, [request.page, request.maxResult, params?.data]);
	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const selectReportType = (e) => {
		setRequest((prev) => ({
			...prev,
			reportType: e.target.value,
			reportValue: '',
			provinceId: ''
		}));
	}
	const handleChange = (e) => {
		const { name, value } = e.target;
		setRequest((prev) => ({ ...prev, [name]: value }));
	};
	const selectReportValue = (e) => {
		setRequest((prev) => ({
			...prev,
			reportValue: e.target.value,
		}));
	}
	const loadPackageType = async () => {
		const rsp = await dispatch(callGetActiveVehicleType());
		if (rsp?.payload?.responseCode === "00000") {
			setPackageListType(rsp?.payload?.data)
		}
	}
	const loadPackage = async (id) => {
		const rsp = await dispatch(callGetActiveVehiclePackage({ vehiclesTypeId: id }));
		if (rsp?.payload?.responseCode === "00000") {
			setPackageList(rsp?.payload?.data)
			return rsp?.payload?.data
		}
		return null
	}
	const selectePackageType = async (e) => {
		e.preventDefault();
		if (!e.target.value) {
			setRequest((prev) => ({
				...prev,
				package: null,
				packageId: "",
				packageType: ""

			}));
			return
		}
		setRequest((prev) => ({
			...prev,
			packageType: e.target.value

		}));
		loadPackage(e.target.value)
	}

	const loadData = async (type = 1, agenCode, startDate, endDate, status, reportValue) => {
		console.log("request", request.status)
		let data = {
			type: type,
			page: request.page,
			maxResult: request.maxResult,
			keyword: request.keyword,
			startDate: startDate || fromDate,
			endDate: endDate || toDate,
			startPayDate: fromPayDate,
			endPayDate: toPayDate,
			reportValue: reportValue || request.reportValue,
			provinceId: request.provinceId,
			status: status || request.status,
			agentCode: agenCode || request.agentCode,
			contractNo: request.contractNo,
			packageId: request.packageId,
			vehicleBrandId: request.vehicleBrandId,
			isRepairCenter: request.isRepairCenter,
			updateBy: request.updateBy
		};
		const rsp = await dispatch(callGetExportVehicleContract(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setVehicleContractList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChangeContract = (e) => {
		setRequest((prev) => ({ ...prev, contractNo: e.target.value }));
	};

	const handleChangeAgentCode = (e) => {
		setRequest((prev) => ({ ...prev, agentCode: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const selectstartDate = (e) => {
		setRequest((prev) => ({
			...prev,
			startDate: e.target.value,
		}));
	}

	const selectendDate = (e) => {
		setRequest((prev) => ({
			...prev,
			endDate: e.target.value,
		}));
	}

	const selectStatus = (e) => {
		setRequest((prev) => ({
			...prev,
			status: e.target.value,
		}));
	}

	const downloadExcel = async () => {
		try {
			let data = {
				type: request.type,
				page: 0,
				maxResult: totalRecord,
				keyword: request.keyword,
				startDate: fromDate,
				endDate: toDate,
				startPayDate: fromPayDate,
				endPayDate: toPayDate,
				status: request.status,
				agentCode: request.agentCode,
				contractNo: request.contractNo,
				packageId: request.packageId,
				reportValue: request.reportValue,
				provinceId: request.provinceId,
				vehicleBrandId: request.vehicleBrandId,
				isRepairCenter: request.isRepairCenter,
				updateBy: request.updateBy,
				reportValue: request.reportValue,
				provinceId: request.provinceId,
			};
			let response = await callExportVehicleContract(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = __t("uiText.text335", { value1: moment().format("YYYYMMDDHHmmss") });
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						{Object.keys(params).length > 0 && (
							<BackPrevious />
						)}
						<h4>{t("menu.report.vehicleInsurance")}</h4>

						<div className="group-button-header">
							<button className="btn btn-success" onClick={downloadExcel}>
								<i className="fas fa-file-export"></i> {t("button.exportExcel")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-2 form-group">
													<label>{t('startDate')}</label>
													<DatePicker
														selected={fromDate}
														onChange={date => setFromDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('endDate')}</label>
													<DatePicker
														selected={toDate}
														onChange={date => setToDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('endDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('search.contractNumber')}</label>
													<input
														type="text"
														name="contractNumber"
														className="form-control-uld"
														placeholder={t('search.contractNumber') + "..."}
														onChange={handleChangeContract}
														value={request.contractNo}
														autoComplete="off"
													/>
												</div>

												<div className="col-md-2">
													<div className="form-group">
														<label>{t('report.lifeInsurance.agentCode')}</label>
														<input
															type="text"
															name="agentCode"
															className="form-control-uld"
															placeholder={t('report.lifeInsurance.agentCode') + "..."}
															onChange={handleChangeAgentCode}
															value={request.agentCode}
															autoComplete="off"
															required />
													</div>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('status.text')}</label>
													<select className="chosen-single form-select"
														onChange={selectStatus}
														value={request.status}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															insuranceStatus.map((item) => (
																<option key={item.id} value={item.status}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-md-2 form-group">
													<label>{t('report.customer.reportTypeName')}</label>
													<select className="chosen-single form-select"
														onChange={selectReportType}
														value={request.reportType}
													>
														{
															reports.reportTypeVehicle.map((item) => (
																<option key={item.id} value={item.id}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												{
													request.reportType == 1 ?
														<div className="col-md-3 form-group">
															<label>{t('report.customer.region.name')}</label>
															<select className="chosen-single form-select"
																onChange={selectReportValue}
																value={request.reportValue}
															>
																{
																	reports.region.map((item) => (
																		<option key={item.key} value={item.key}>{t(item.name)}</option>
																	))
																}
															</select>
														</div> : null
												}
												{request.reportType == 2 && < div className="col-md-3 form-group">
													<label>{t('search.province')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="provinceId"
														value={request.provinceId}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															provinceList.map((item) => (
																<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
															))
														}
													</select>
												</div>}
												<div className="col-md-2 form-group">
													<label>{t('contracts.life.packageType')} <span className="text-danger">*</span> </label>
													<select className="chosen-single form-select"
														name="packageType"
														onChange={selectePackageType}
														value={request?.packageType}
														required
														disabled={request.contractNumber}

													>
														<option key={0} value="">{t("pleaseSelect")}</option>
														{

															packageListType.map((item) => (
																<option key={item.id} value={item.id}>{item.nameLa}</option>
															))
														}
													</select>
												</div>
												<div className="col-md-2 form-group">
													<label>{t('contracts.life.package')} <span className="text-danger">*</span> </label>
													<FilterableDropdown
														isDisabled={request.contractNumber}
														options={packageList}
														label={'optionNameLa'}
														valueKey={'packageId'}
														type={['LONG', 'SHORT']}
														value={request?.package}
														onChange={(val) => setRequest((prev) => ({
															...prev,
															package: val,
															packageId: val.packageId

														}))}
														typeDefault={'LONG'}
														filteredTypeInput={request?.packageType}
														onChangeType={(val) => console.log("Selected:", val)}
													/>
												</div>
												<div className="col-md-2 form-group">
													<label>{t('uiLabels.paymentDate')} - {t('startDate')}</label>
													<DatePicker
														selected={fromPayDate}
														onChange={date => setFromPayDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('endDate')}</label>
													<DatePicker
														selected={toPayDate}
														onChange={date => setToPayDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('endDate')}
														className="form-control-uld"
													/>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
	columns={[
							{ labelKey: "report.vehicleInsurance.agentCode", key: "agentCode" },
							{ labelKey: "report.vehicleInsurance.region", key: "region", render: (val) => val ? <span className="badge bg-success">{val}</span> : '-' },
							{ labelKey: "report.vehicleInsurance.provinceName", key: "provinceName" },
							{ labelKey: "report.vehicleInsurance.agentName", key: "agentName" },
							{ labelKey: "report.vehicleInsurance.contractNo", key: "contractNo" },
							{ labelKey: "report.vehicleInsurance.isRenew", key: "isRenew", render: (val) => (val === 1 || val === true) ? <span className="badge bg-info">{__t("uiText.text436")}</span> : <span className="badge bg-secondary">{__t("uiText.text437")}</span> },
							{ labelKey: "report.vehicleInsurance.createDate", key: "createDate", render: (val) => val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : '-' },
							{ labelKey: "report.vehicleInsurance.signedDate", key: "signedDate", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "report.vehicleInsurance.expiredDate", key: "expiredDate", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "report.vehicleInsurance.insuranceType", key: "insuranceType", render: (val) => val || 'Motor' },
							{ labelKey: "report.vehicleInsurance.productType", key: "productType" },
							{ labelKey: "report.vehicleInsurance.option", key: "option" },
							{ labelKey: "report.vehicleInsurance.customerName", key: "custName" },
							{ labelKey: "report.vehicleInsurance.customerAddress", key: "custAddress" },
							{ labelKey: "report.vehicleInsurance.phone", key: "phone" },
							{ labelKey: "report.vehicleInsurance.brandName", key: "brandName" },
							{ labelKey: "report.vehicleInsurance.vehicleModel", key: "vehicleModel" },
							{ labelKey: "report.vehicleInsurance.engineNo", key: "engineNo" },
							{ labelKey: "report.vehicleInsurance.vehicleIdentificationNo", key: "vehicleIdentificationNo" },
							{ labelKey: "report.vehicleInsurance.licensePlate", key: "licensePlate" },
							{ labelKey: "report.vehicleInsurance.packagePrice", key: "packagePrice", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.civelLiability", key: "civelLiability", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.guaranteenFee", key: "guaranteenFee", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.discountRate", key: "discountRate", render: (val) => `${val || 0}%` },
							{ labelKey: "report.vehicleInsurance.sumTotal", key: "sumTotal", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.vatValue", key: "vatValue", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.registerFee", key: "registerFee", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.companyReceivedAmount", key: "rvpeAmount", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.totalAmount", key: "totalAmount", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.commissionRate", key: "commissionRate", render: (val) => `${val || 0}%` },
							{ labelKey: "report.vehicleInsurance.grossCom", key: "grossCom", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.comTax", key: "comTax", render: (val) => `${FormatCurrencys(val || 0)}%` },
							{ labelKey: "report.vehicleInsurance.netCom", key: "netCom", render: (val) => FormatCurrencys(val || 0) },
							{ labelKey: "report.vehicleInsurance.companyReceiveTotal", key: "companyReceiveTotal", render: (val) => FormatCurrencys(val || 0) },
						]}
	data={{ result: vehicleContractList }}
	rowKey="contractNo"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={true}
	rowNumberOffset={(request.page - 1) * request.maxResult}
/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
